import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MasterStatsModel, StatsDisplayModel } from 'src/app/api-providers/models/dashboard.model';
import { DashboardViewModel } from 'src/app/api-providers/view-models/dashboard.view.model';
import { AppCommon } from 'src/app/api-providers/app-common';
import { FeedbackFilterModel } from 'src/app/api-providers/models/feedback.model';
 
@Component({
  selector: 'app-feedback-stats',
  templateUrl: './feedback-stats.component.html',
  styleUrls: ['./feedback-stats.component.scss']
})
export class FeedbackStatsComponent implements OnChanges  {
  loggedInUser:any
  @Input() feedbackUpdate:FeedbackFilterModel
  @Input() myFeedbackPage: boolean = false;
  @Output() dashdata = new EventEmitter();
  dashboardStatsResponseModel = new BehaviorSubject<MasterStatsModel>(new MasterStatsModel());
  @Input() statsLoad  = new BehaviorSubject(false);

  dashItemsValues = [
    {id: 1, name: 'Total', model: 0, icon: 'bars', enabled: true, selected: true},
    {id: 2, name: 'In-Progress', model: 0, icon: 'pull-request', enabled: true, selected: false},
    {id: 3, name: 'Planned', model: 0, icon: 'node-collapse', enabled: true, selected: false},
    {id: 4, name: 'Completed', model: 0, icon: 'check', enabled: true, selected: false},
    {id: 5, name: 'Unassigned', model: 0, icon: 'holder', enabled: true, selected: false},
    {id: 6, name: 'Rejected', model: 0, icon: 'stop', enabled: true, selected: false},
  ]
  enbledItems = 0

  constructor(private vm: DashboardViewModel){
    this.vm.feedbackStatsComponent = this
    
  }

  ngOnInit():void {
    this.vm.subscribeToFeedbackStata(this.dashboardStatsResponseModel)
    if(this.myFeedbackPage === true){
      this.dashItemsValues.find(el => el.id === 5).enabled = false;
      this.loggedInUser = AppCommon.getloggedInObject().user.id
    }
    this.getDashboardStats();


    this.enbledItems = this.dashItemsValues.filter(e => e.enabled == true ).length
   
    this.statsLoad.subscribe( e => {if(e){this.getDashboardStats();}});
     
  }

  ngOnChanges(changes: SimpleChanges): void {
   
    if (changes['feedbackUpdate'] && this.feedbackUpdate) {
      this.getDashboardStats()
    }
  }

  getDashboardStats(){
    this.vm.getDashboardStats(this.loggedInUser, this.feedbackUpdate);
  }

  showData(name){
    this.dashItemsValues.forEach(element => {
      if(element.name === name){
        element.selected = true;
      } else {
        element.selected = false;
      }
    });
    this.dashdata.emit(name);
  }

  dashboardStartsReceived(){
    this.dashItemsValues[0].model = this.dashboardStatsResponseModel.value.feedback_count
    this.dashItemsValues[1].model = this.dashboardStatsResponseModel.value.in_progress
    this.dashItemsValues[2].model = this.dashboardStatsResponseModel.value.planned
    this.dashItemsValues[3].model = this.dashboardStatsResponseModel.value.completed
    this.dashItemsValues[4].model = this.dashboardStatsResponseModel.value.unassigned
    this.dashItemsValues[5].model = this.dashboardStatsResponseModel.value.rejected
  }
 
}
